import React,{ useState, useEffect } from 'react'
import Header from '../Integration/Header';
import BarraMenu from "../Integration/BarraMenu";
import  FbGetProducctService from '../../Middleware/Firebase/FbGetProducctService';
import FooterMenu from '../Integration/FooterMenu'
import { useLocation } from 'react-router-dom';
import FootPageNumber from '../Integration/FootPageNumber';

function PageService() {
 const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(30); // você já usava 30
  const [totalItems, setTotalItems] = useState(0);

  // Sempre que a rota mudar (categoria/coleção), volte para página 1
  useEffect(() => {
    setCurrentPage(1);
  }, [location.pathname]);








  return (
    <div>

    <Header/>
    <BarraMenu/>


    <FbGetProducctService
          pageSize={pageSize}
          currentPage={currentPage}
          onTotalChange={setTotalItems}
    />

    <FootPageNumber 
       totalItems={totalItems}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
    />
    <FooterMenu/>
      
        
     
        
        </div>
  )
}

export default PageService